module.exports = __webpack_public_path__ + "media/images/cleaning/main_image1@3x-f0ff35cad46c5bbfbc889a6141330d1a.jpg";